var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "market_filter" },
    [
      _c(
        "b-overlay",
        { attrs: { show: _vm.is_load } },
        [
          _c(
            "b-tabs",
            { attrs: { pills: "", card: "", vertical: "" } },
            _vm._l(_vm.markets, function (market, idx) {
              return _c(
                "b-tab",
                {
                  key: market.type,
                  attrs: { active: idx === 0 },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "fs-lg px-4 text-center position-relative",
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.__t(market.type)) +
                                    "\n\n                        "
                                ),
                                _vm.selectedInMarket(market) > 0
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-icon pos-top pos-right",
                                      },
                                      [
                                        _vm._v(
                                          "\n                           " +
                                            _vm._s(
                                              _vm.selectedInMarket(market)
                                            ) +
                                            "\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-card-text",
                    [
                      market._loading
                        ? _c("div", { staticClass: "text-muted py-3" }, [
                            _vm._v("Завантаження…"),
                          ])
                        : _c(
                            "b-list-group",
                            [
                              _vm._l(market.locations, function (loc) {
                                return _c(
                                  "b-list-group-item",
                                  {
                                    key: "m" + market.id + "_l" + loc.id,
                                    staticClass:
                                      "d-flex align-items-center justify-content-between",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "text-truncate pr-3" },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(loc.title) +
                                            "\n                                "
                                        ),
                                        _c("div", [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(loc.uniq_id) +
                                              "\n                                "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-switch",
                                      },
                                      [
                                        _c("input", {
                                          staticClass: "custom-control-input",
                                          attrs: {
                                            id:
                                              "loc-" + market.id + "-" + loc.id,
                                            type: "checkbox",
                                          },
                                          domProps: {
                                            checked:
                                              _vm.role_item.delivery_ids.includes(
                                                loc.id
                                              ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.toggleLocation(
                                                market,
                                                loc
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("label", {
                                          staticClass: "custom-control-label",
                                          attrs: {
                                            for:
                                              "loc-" + market.id + "-" + loc.id,
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              !market.locations.length
                                ? _c(
                                    "b-list-group-item",
                                    { staticClass: "text-muted" },
                                    [
                                      _vm._v(
                                        "\n                            Немає локацій\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }